import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ClientMealsPlanDetails } from "@fitness-app/data-models/entities/ClientNutrition";
import { type MealsPlanDetails } from "@fitness-app/data-models/entities/MealsPlan";
import { getUniqDishesIdsInPlan } from "@fitness-app/utils/src/nutrition/generateMealsPlanDetails";

import { type AsyncThunkCreator } from "../../../index";
import { MEALS_PLANS_REDUCER_NAME } from "../types";

type Payload = {
  days: MealsPlanDetails["weeks"][number]["days"];
  id: string;
};

export const updatedMealsPlanDays = createAsyncThunk<ClientMealsPlanDetails, Payload, AsyncThunkCreator<string>>(
  `${MEALS_PLANS_REDUCER_NAME}/updatedMealsPlanDays`,
  async (payload, { rejectWithValue, extra: { db } }) => {
    const { error, data } = await db
      .from("client_meals_plan_details")
      .update({
        dishesIds: getUniqDishesIdsInPlan(payload.days),
        weeks: [
          {
            weekNumber: 1,
            days: payload.days,
          },
        ],
        updatedAt: new Date().toISOString(),
      })
      .eq("id", payload.id)
      .select()
      .returns<ClientMealsPlanDetails[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data[0]!;
  },
);
